import { diff } from 'jest-diff';
import chalk from 'chalk';

const DIVIDER_WIDTH = 60;

export function renderDivider() {
  return '─'.repeat(DIVIDER_WIDTH);
}

export interface DiffOptions {
  expectedLabel?: string;
  actualLabel?: string;
}

export function renderDiff(
  expected: string | string[],
  actual: string | string[],
  options: DiffOptions = {}
): string {
  const { expectedLabel = 'Expected', actualLabel = 'Actual (insights)' } =
    options;

  const expectedFormatted =
    typeof expected === 'string' ? expected.trim() : expected;
  const actualFormatted = typeof actual === 'string' ? actual.trim() : actual;

  const result = diff(expectedFormatted, actualFormatted, {
    aAnnotation: expectedLabel,
    bAnnotation: actualLabel,
    includeChangeCounts: false,
    contextLines: 3,
  });

  return result ?? chalk.dim('(no differences)');
}

export function renderTestCaseHeader(
  index: number,
  total: number,
  alertLink?: string,
  actionTitle?: string
): string {
  const baseLines = [
    '',
    renderDivider(),
    chalk.bold(`Test Case ${String(index + 1)}/${String(total)}`),
  ];

  const alertLine = alertLink ? [chalk.dim(`Alert: ${alertLink}`)] : [];
  const actionLine = actionTitle ? [chalk.cyan(`Action: ${actionTitle}`)] : [];

  return [...baseLines, ...alertLine, ...actionLine, renderDivider(), ''].join(
    '\n'
  );
}

export function renderShortAnswer(shortAnswer?: string): string {
  if (!shortAnswer) return '';
  return `\n${chalk.bold('Short Answer:')} ${shortAnswer}\n`;
}

export default {
  renderDiff,
  renderDivider,
  renderTestCaseHeader,
  renderShortAnswer,
};
